module.exports.DEFAULT_COUNTRY_CODE = "IN";
module.exports.DEFAULT_STATE_CODE = "GJ";
module.exports.STORAGE_TYPE = process.env.VUE_APP_STORAGE_TYPE;
module.exports.AFFILITAION_ON= process.env.VUE_APP_AFFILIATEON
// API's
module.exports.SUPPORT_MAIL = "/api/v2/support-mail";
module.exports.SEND_INVITATION_EMAIL = "/api/v2/sendInvitationEmail";
module.exports.SEND_VARIFICATION_EMAIL = "/api/v2/sendVerificationEmail";
module.exports.INVITATION_CONFIRMATION = "/api/v2/checkPermission";
module.exports.VERIFY_EMAIL = "/api/v2/verifyEmail";
module.exports.IMPORT_SETTINGS = "/api/v1/importSettings";
module.exports.SEND_NOTIFICATION = "/api/v1/sendNotification";
module.exports.REMOVE_SPRINT_FOLDER = "/api/v1/removeSprintOperations";
module.exports.GET_SUBSCRIPTION_DATA = "/api/v1/getSubscription";
module.exports.GET_PAYMENT_CUSTOMER = "/api/v1/getpaymentCustomer";
module.exports.DELETE_SUBSCRIPTION = "/api/v1/cancleSubscriptionChargebee";
module.exports.RESTART_SUBSCRIPTION = "/api/v1/removeScheduleCancellationChargebee";
module.exports.GET_INVOICE_PDF = "/api/v1/getInvoicePDF";
module.exports.UPDATE_CUSTOMER_BILLING = "/api/v2/updateCustomerBilling";
module.exports.ADD_TIMELOG = "/api/v2/manualLogtime";
module.exports.DELETE_TIMELOG = "/api/v2/deleteManualLogtime";
module.exports.CREATE_COMPANY = "/api/v2/company/create";
module.exports.CHECK_FREE_COMPANY = "/api/v1/freeCompanyCount";
module.exports.PREPARE_NOTIFICATION_DATA = "/api/v1/prepare-notification-data";
module.exports.ADD_MILESTONE = "/api/v1/addmilestone";
module.exports.UPDATE_MILESTONE = "/api/v1/updatemilestone";
module.exports.DELETE_MILESTONE = "/api/v1/deletemilestone";
module.exports.CLEAR_MILESTONE_STATUS = "/api/v1/clearmilestonestatus";
module.exports.CANCEL_MILESTONE_STATUS = "/api/v1/cancelmilestonestatus";
module.exports.REFUND_AMOUNT = "/api/v1/refundamount";
module.exports.DRAGGABLE_MILESTONE = "/api/v1/draggablemilestone";
module.exports.SEND_FCM = "/api/v1/send-fcm";
module.exports.UPDATA_TASK_INDEX = "/api/v1/taskIndex";
module.exports.ONLOAD_UPDATE_TASK_INDEX = "/api/v1/updateTaskIndexOnload";
module.exports.CREATE_PROJECT = "/api/v1/createProject";
// AI Project Generator (Modules/AIProjectGenerator)
module.exports.AI_PROJECT_UPLOAD_BRIEF = "/api/v1/ai/project/upload-brief";
module.exports.AI_PROJECT_PLAN = "/api/v1/ai/project/plan";
module.exports.AI_PROJECT_CLARIFY = "/api/v1/ai/project/clarify";
module.exports.AI_PROJECT_BRIEF = "/api/v1/ai/project/brief";
module.exports.AI_PROJECT_GUIDE = "/api/v1/ai/project/guide";
module.exports.AI_PROJECT_EXECUTE = "/api/v1/ai/project/execute";
module.exports.AI_PROJECT_EVENTS = "/api/v1/ai-progress";
// AHE-3777 — AI task generation into an EXISTING project. projectId is a
// path segment: `${AI_PROJECT_TASKS_BASE}/${projectId}/tasks/plan|execute`.
module.exports.AI_PROJECT_TASKS_BASE = "/api/v1/ai/project";
// "Write with AI" for the task/project description editor (Modules/AI)
module.exports.AI_WRITE_DESCRIPTION = "/api/v1/ai/description";
module.exports.AI_TRANSCRIBE = "/api/v1/ai/transcribe";
module.exports.AI_MEETING_NOTES = "/api/v1/ai/meeting-notes";
module.exports.AI_CHAT_SUMMARY = "/api/v1/ai/chat-summary";
module.exports.AI_NOTES_TO_TASKS = "/api/v1/ai/notes-to-tasks";
module.exports.AI_CHAT_ASK = "/api/v1/ai/chat-ask";
module.exports.AI_CHAT_ASK_POST = "/api/v1/ai/chat-ask/post";
module.exports.AI_TASK_SUMMARY = "/api/v1/ai/task-summary";
module.exports.AI_TASK_VALUES = "/api/v1/ai/task-values";
module.exports.AI_TASK_CATEGORY = "/api/v1/ai/task-category";
module.exports.AI_TASK_ASSIST = "/api/v1/ai/task-assist";
module.exports.AI_TASK_NEXT_STEPS = "/api/v1/ai/task-next-steps";
module.exports.AI_TASK_RESEARCH = "/api/v1/ai/task-research";
module.exports.AI_SELECTION_IMPROVE = "/api/v1/ai/selection/improve";
module.exports.AI_SELECTION_TASKS = "/api/v1/ai/selection/tasks";
module.exports.WASABI_UPLOAD_FILE = "/api/v1/wasabi/uploadFile";
module.exports.WASABI_UPLOAD64_FILE = "/api/v1/wasabi/uploadFile_64";
module.exports.WASABI_RETRIVE_USER_PROFILE = "/api/v1/wasabi/retriveUserProfile";
module.exports.WASABI_RETRIVE_OBJECT = "/api/v1/wasabi/retriveObject";
module.exports.WASABI_DELETE_FILE = "/api/v1/wasabi/deleteFile";
module.exports.CREATE_USER_V2 = '/api/v2/createUser';
module.exports.MONGO_OPRATION = '/api/v1/mongoOpration';
module.exports.INVITATION_PREVIEW = '/api/v2/auth/invitation-preview';
module.exports.INVITATION_ACCEPT = '/api/v2/auth/invitation-accept';
module.exports.TASKTYPE = '/api/v1/projectSetting/taskType';
module.exports.TASKSTATUS = '/api/v1/projectSetting/taskStatus';
module.exports.SPRINT = '/api/v1/sprint';
module.exports.SPRINT_HOURS = '/api/v2/sprints/hours';
module.exports.CALL_ICE_CONFIG = '/api/v2/calls/ice-config';
module.exports.CALL_NOTES = '/api/v2/calls/notes';
module.exports.FOLDER = '/api/v1/folder';
module.exports.PROJECTS_V2 = '/api/v2/projects';
module.exports.REMOVE_USER_NOTIFICATION = '/api/v1/removeUserNotification';
module.exports.GENERATETOKEN_V2 = '/api/v2/generateToken';
module.exports.TRACKER_CODE = '/api/v2/auth/tracker-code';
module.exports.UPDATE_UNREADREAD_COMMENTS_COUNT = '/api/v1/updateunreadcommentscount';
module.exports.UNSET_COMMENTS_COUNT = '/api/v1/unsetCommentCounts';
module.exports.V2_TASKS = '/api/v2/tasks';
module.exports.V2_TASKS_BULK = '/api/v2/tasks/bulk';
module.exports.V2_TASKS_EVERYTHING = '/api/v2/tasks/everything';
module.exports.V2_TASKS_EVERYTHING_VIEWS = '/api/v2/tasks/everything/views';
module.exports.V1_TASKS_IMPORT = '/api/v1/importTasks';
module.exports.API_URI = window.location.origin;
module.exports.DOMAIN_URI = window.location.origin;
module.exports.PROJECT_RULES = '/api/v1/importSettingsProjectFunction';
module.exports.GET_CARD_DETAILS = '/api/v2/getCardDetails';
module.exports.CREATE_PAYMENT_SOURCE_CHARGEBEE = '/api/v2/createPaymnetSourceChargebee';
module.exports.CREATE_SUBSCRIPTION_CHARGEBEE = '/api/v2/createSubscriptionChargebee';
module.exports.UPDATECARDFORSUBSCRIPTION= '/api/v1/updateCardForSubscription';
module.exports.CANCELSUBSCRIPTIONPAYMENT = '/api/v1/cancleSubscriptionPayment';
module.exports.REMOVESCHEDULECANCELLATION = '/api/v2/removeScheduleCancellationChargebee';
module.exports.GETINVOICEANDCREDITNOTES = '/api/v1/getInvoiceAndCreditNotes';
module.exports.UPDATESUBSCRIPTIONPAYMENTSTIMATE = '/api/v1/updateSubscriptionPaymentEstimate';
module.exports.UPDATESUBSCRIPTIONPAYMENT = '/api/v1/updateSubscriptionPayment';
module.exports.ADDANDREMOVEUSERFROMSUBSCRIPTIONESTIMATE = '/api/v1/addAndRemoveUserInPaymentSubscriptionEstimate';
module.exports.ADDANDREMOVEUSERFROMSUBSCRIPTION = '/api/v1/addAndRemoveUserInPaymentSubscription';
module.exports.CHECKSENDINVITATION = 'api/v1/checkSendInviatation';
module.exports.CHECKSUBSCRIPTIONSCHEDULE = '/api/v1/checkSubscriptionSchedule';
module.exports.REMOVESUBSCRIPTIONSCHEDULECHANGES = '/api/v1/removeSubscriptionScheduledChanges';
module.exports.PENDING_INVOICE_PAYMENT = '/api/v1/payPendingInvoice';
module.exports.GET_INVOICE_AND_CREDITNOTE_URL = '/api/v1/getInvoiceAndCreditNoteURL';
module.exports.TRACKER_USER_PERMISSION_MANAGEMENT = '/api/v1/manageTrackerUserPermission';
module.exports.IMPORT_NOTIFICATION_SETTING = '/api/v1/importSettingsNotification';
module.exports.GLOBAL_PROJECT_TEMPLATE = '/api/v1/getGlobalTemplate';
module.exports.CUSTOMER_ADDRESS_ADD_PADDLE = '/api/v1/customerAddressPaddle'
module.exports.GETTRANSECTIONPDFURL = '/api/v1/getTransectionPDFURL';
module.exports.GET_CUSTOMER_CREDIT = '/api/v1/getCustomerCredit';
module.exports.TABSYNCTASKGET = '/api/v1/tabSyncTask';
module.exports.VERSION_UPDATE_NOTIFY = 'api/v1/versionUpdateNotify';
module.exports.PROJECT_TEMPLATE = '/api/v1/project/template/custom';
module.exports.TASK_TEMPLATES = '/api/v2/task-templates';
module.exports.VIEW_TEMPLATES = '/api/v2/view-templates';
module.exports.WHITEBOARDS = '/api/v2/whiteboards';
module.exports.PROJECTS_CHECKLIST = '/api/v1/project/checklist';
module.exports.API_PROJECT_STATUS_TEMPLATE = '/api/v1/project-status-template';
module.exports.RESTRICTED_EXTENSIONS = '/api/v1/restricted-extensions';
module.exports.USER_ID_COLLECTION = '/api/v1/collection/userid';
module.exports.API_MEMBERS = '/api/v1/members';
module.exports.API_IMPORT_USER = '/api/v1/importUser';
module.exports.API_ROOT_MEMBERS = '/api/v1/root-members';
module.exports.API_COMMENTS = '/api/v1/comments';
module.exports.API_GET_REMAINING_PROJECTS = '/api/v1/get-remaining-projects';
module.exports.API_TAGS = '/api/v1/project/tags';
module.exports.GETCOMPANYREFFERCODE = '/api/v1/getcompany-reffercode';
module.exports.VALIDATECOMPANYREFFERCODE = '/api/v1/validateRefferalCode';
module.exports.GETREFERRALPERCENTAGE = '/api/v1/getreferralpercentage';
module.exports.GETCUSTOMERPROMOTIONALCREDIT = '/api/v1/promotional-credit'
// USER AUTH
module.exports.FORGOTPASSWORD = '/api/v2/auth/forgot-password';
module.exports.TOKEN_VERIFY_FORGOTPASSWORD = '/api/v2/auth/token-verify-forgotpassword';
module.exports.RESETPASSWORD = '/api/v2/auth/reset-password';
module.exports.LOGIN = '/api/v2/auth/login';
module.exports.TWO_FA_STATUS = '/api/v2/auth/2fa/status';
module.exports.TWO_FA_SETUP = '/api/v2/auth/2fa/setup';
module.exports.TWO_FA_VERIFY = '/api/v2/auth/2fa/verify';
module.exports.TWO_FA_DISABLE = '/api/v2/auth/2fa/disable';
module.exports.TWO_FA_VALIDATE = '/api/v2/auth/2fa/validate';
module.exports.MAGIC_LINK = '/api/v2/auth/magic-link';
module.exports.SSO_DISCOVER = '/api/v2/sso/discover';

// Webhooks / integrations (Modules/Webhooks)
module.exports.WEBHOOKS = '/api/v2/webhooks';
module.exports.WEBHOOK_EVENTS = '/api/v2/webhooks/events';
// Workspace secrets by handle (Modules/Secrets): metadata only, owner or admin
module.exports.SECRETS = '/api/v2/secrets';
module.exports.AUTH = '/api/v2/auth';
module.exports.DELETE_SESSION = '/api/v2/session/delete';
module.exports.UPDATE_SESSION = '/api/v2/session/update';
module.exports.API_SIGNUP_WITH_GOOGLE = '/api/v2/google-signup';
module.exports.API_SIGNUP_WITH_GITHUB = '/api/v2/github-signup';
module.exports.API_SIGNUP_WITH_GITLAB = '/api/v2/gitlab-signup';

//Storage Routes
//BUCKETS ROUTES
module.exports.CREATE_BUCKET = '/api/v1/createBucket';
module.exports.UPDATE_BUCKET = '/api/v1/updateBucket';
module.exports.GET_BUCKET = '/api/v1/getBucket';
module.exports.REMOVE_BUCKET = '/api/v1/removeBucket';
module.exports.GET_BUCKET_SIZE = '/api/v1/getBucketSize';

//FILES ROUTES
module.exports.REMOVE_FILE = '/api/v1/storage/removeFile';
module.exports.GET_SIGNED_OR_PUBLIC_URL = '/api/v1/generateSignedUrl';
// General-purpose (standalone) reminders — Modules/GeneralReminders. Distinct
// from the task-scoped reminder flow at /api/v1/reminders.
module.exports.GENERAL_REMINDERS = '/api/v1/general-reminders';
module.exports.UPLOAD_FILE = '/api/v1/storage/uploadFile';
module.exports.UPLOAD_FILE_64 = '/api/v1/storage/uploadFileBase64';
module.exports.GETPROMPTS = '/api/v1/getPrompts';
module.exports.FINDONEPROMPTS = '/api/v1/findOnePrompts';
module.exports.GETAICATEGORY = '/api/v1/getAiCategory';
module.exports.USER_UPATE = '/api/v1/user';
module.exports.USER_AND_COMAPNY_CHECK = '/api/v1/userAndCompanyCheck';
module.exports.DELETE_USER_CHAT = '/api/v1/deleteUserChat';
module.exports.SAVE_BRAND_SETTINGS_INFORMATION = '/api/v1/saveBrandSettingsData';
module.exports.GET_BRAND_SETTINGS_INFORMATION = '/api/v1/getBrandSettingsData';
module.exports.PROJECTACTIONS = 'project';
module.exports.PROJECTALLTASKUPDATE = 'project/allTask';
module.exports.GET_SPRINT_OR_PROJECT= 'project/sprintFolder';
module.exports.PROJECTSPRINTUPDATE = 'project/sprint';
module.exports.COMPANYACTIONS = '/api/v1/company';
module.exports.CACHECLEAR = '/api/v1/removeCache';
module.exports.PROJECTSEARCH = '/api/v1/project/search';
module.exports.PROJECT_GLOBAL_FILTER = '/api/v1/project/filter';
module.exports.SUBMIT_ENV_STEP_FORM = '/api/v1/update-submit';
module.exports.GET_GENERAL_NOTES = '/api/v1/generalNotes';
module.exports.TEAMS = '/api/v1/teams';
module.exports.TASK_GLOBAL_FILTER = '/api/v1/task/filter';
module.exports.ADVANCE_GLOBAL_FILTER = '/api/v1/advance/filter';
module.exports.CURRENCY = '/api/v1/currency';
module.exports.PROJECTRULES = '/api/v1/projectRules';
module.exports.COMPANYINVITATION = '/api/v1/company-invitation';
module.exports.ESTIMATED_TIME = '/api/v1/estimatedTime';
module.exports.NOTIFICATION = '/api/v1/notifications';
module.exports.MILESTONE = '/api/v1/milestone';
module.exports.MILESTONE_PROJECT = '/api/v1/milestone/project';
module.exports.MILESTONE_REPORT = '/api/v1/milestoneReport';
module.exports.PROJECT = '/api/v1/project';
module.exports.CUSTOM_FIELD = '/api/v1/customField';
module.exports.TASK_TYPE_TEMPLATE = '/api/v1/templates/taskType';
module.exports.TASK_STATUS_TEMPLATE = '/api/v1/templates/taskStatus';
module.exports.TOURS='/api/v1/tours'
module.exports.GET_TACKER="/api/v1/tracker";
module.exports.TASK_TYPE_SETTING_TEMPLATE = '/api/v1/setting/taskType';
module.exports.TASK_STATUS_SETTING_TEMPLATE = '/api/v1/setting/taskStatus';
module.exports.PROJECT_STATUS_SETTING_TEMPLATE = '/api/v1/setting/projectStatus';
module.exports.RULES = '/api/v1/securityPermissions';
module.exports.PROJECTS_APPS = '/api/v1/projects-apps';
module.exports.PROJECTS_TABS = '/api/v1/projectTabs';
module.exports.PROJECT_DASHBOARD = '/api/v1/project-dashboard';
module.exports.TIMESHEET = '/api/v1/timesheet';
module.exports.TIMESHEET_APPROVAL = '/api/v2/timesheet-approval';
module.exports.SSO_CONFIG = '/api/v2/sso/config';
module.exports.SSO_VERIFY_DOMAIN = '/api/v2/sso/config/verify-domain';
module.exports.AUDIT_LOGS = '/api/v1/audit-logs';
module.exports.AUDIT_UNDO = '/api/v1/audit-logs/:id/undo';
module.exports.AGENTS = '/api/v2/agents';
module.exports.AGENT_METRICS = '/api/v2/agents/metrics';
module.exports.AGENT_ALERTS = '/api/v2/agents/alerts';
module.exports.AGENT_RUNS = '/api/v2/agents/runs';
module.exports.AGENT_REPORTS = '/api/v2/agents/reports';
module.exports.AGENTS_RUNNABLE = '/api/v2/agents/runnable';
module.exports.AGENTS_CONNECTED = '/api/v2/agents/connected';
module.exports.AGENTS_CHAT_USABLE = '/api/v2/agents/chat/usable';
module.exports.AGENTS_CHAT_DIRECT = '/api/v2/agents/chat/direct';
module.exports.AGENT_SESSIONS = '/api/v2/agent-sessions';
module.exports.TIMESHEET_HOURS_BY_SOURCE = '/api/v1/timesheet/hours-by-source';
module.exports.AGENT_PROPOSALS = '/api/v2/agents/proposals';
module.exports.AGENT_REGISTRY = '/api/v2/agents/registry';
module.exports.AGENT_SKILLS = '/api/v2/agents/skills';
module.exports.AGENT_ROLES = '/api/v2/agents/roles';
module.exports.AGENT_SKILL_CATALOGUES = '/api/v2/agents/skills/catalogues';
module.exports.AGENT_SKILL_EGRESS_CHECK = '/api/v2/agents/skills/egress-check';
module.exports.AGENT_MANIFEST = '/api/v2/agents/manifest';
module.exports.AGENT_SPEND = '/api/v2/agents/spend';
module.exports.AGENT_ACCOUNT = '/api/v2/agents/account';
module.exports.AGENT_PAUSE_ALL = '/api/v2/agents/pause-all';
module.exports.AGENT_DRAFT = '/api/v2/agents/draft';
module.exports.AGENT_POLICY = '/api/v2/agents/policy';
module.exports.AGENT_PROJECT_POLICY = '/api/v2/agents/project-policy';
module.exports.AGENT_PROJECT_LIMITS = '/api/v2/agents/project-limits';
module.exports.AGENT_STANDING_APPROVALS = '/api/v2/agents/standing-approvals';
module.exports.AGENT_PROJECT_MANAGER = '/api/v2/agents/project-manager';
module.exports.AGENT_WORK_QUEUE = '/api/v2/agents/work-queue';
module.exports.WORKFLOW_RUNS = '/api/v2/workflows/runs';
module.exports.WORKFLOW_APPROVALS = '/api/v2/workflows/approvals';
module.exports.API_TOKENS = '/api/v2/api-tokens';
module.exports.MCP_TOKENS = '/api/v2/api-tokens/mcp';
module.exports.API_TOKENS_NEEDING_EXPIRY = '/api/v2/api-tokens/needing-expiry';
module.exports.API_TOKENS_STEP_CREDENTIALS = '/api/v2/api-tokens/step-credentials';
module.exports.AI_CONNECTION = '/api/v2/api-tokens/ai-connection';
module.exports.MCP_MANIFEST = '/mcp/manifest';
module.exports.OAUTH_CONSENT = '/oauth/consent';
module.exports.OAUTH_CONSENT_DETAILS = '/oauth/consent/details';
module.exports.OAUTH_CONSENT_APPROVAL_REQUEST = '/oauth/consent/approval-request';
module.exports.OAUTH_CLIENT_APPROVALS = '/api/v2/oauth-client-approvals';
module.exports.OAUTH_GRANTS = '/api/v2/oauth-grants';
module.exports.AGENT_CHANGES = '/api/v2/agents/changes';
module.exports.AGENT_TEAM = '/api/v2/agents/team';
module.exports.AGENT_WORKSPACE_GUIDE = '/api/v2/agents/workspace-guide';
module.exports.AGENT_TEAM_STANDUP = '/api/v2/agents/team/standup';
module.exports.AGENT_ROUTABLE = '/api/v2/agents/routable';
module.exports.AGENT_PIPELINE = '/api/v2/agents/pipeline';
module.exports.AGENT_RELEASE = '/api/v2/agents/release';
module.exports.AGENT_SETTINGS = '/api/v2/agents/settings';
module.exports.AGENT_BUDGET = '/api/v2/agents/budget';
module.exports.AGENT_MODELS = '/api/v2/agents/models';
module.exports.AGENT_ROUTING_POLICY = '/api/v2/agents/routing-policy';
module.exports.PROVIDER_KEYS = '/api/v2/provider-keys';
module.exports.CONNECTORS = '/api/v2/connectors';
module.exports.AI_SWITCH = '/api/v2/ai-switch';
module.exports.AGENT_MEMORY_PROJECT = '/api/v2/agents/memory/project';
module.exports.AGENT_MEMORY = '/api/v2/agents/memory';
module.exports.AGENT_PREFERENCES = '/api/v2/agents/preferences';
module.exports.WORKFLOW_STEP_TYPES = '/api/v2/workflows/step-types';
module.exports.WORKFLOW_DEFINITIONS = '/api/v2/workflows/definitions';
module.exports.WORKFLOW_DRY_RUN = '/api/v2/workflows/dry-run';
module.exports.AUTOMATIONS_COMPILE = '/api/v2/automations/compile';
module.exports.AUTOMATIONS_BACKTEST = '/api/v2/automations/backtest';
module.exports.AUTOMATIONS_AI_DRAFT = '/api/v2/automations/draft';
module.exports.AI_ASK = '/api/v1/ai/ask';
module.exports.AI_ASK_SOURCES = '/api/v1/ai/ask/sources';
module.exports.AI_ASK_CARD = '/api/v1/ai/ask/card';
module.exports.AI_ASK_POST = '/api/v1/ai/ask/post';
module.exports.AI_ASK_POST_TARGETS = '/api/v1/ai/ask/post/targets';
module.exports.AI_ASK_STREAM = '/api/v1/ai/ask/stream';
module.exports.AI_ASK_PLAN = '/api/v1/ai/ask/plan';
module.exports.AI_ASK_THREADS = '/api/v1/ai/ask/threads';
module.exports.AI_FEEDBACK = '/api/v1/ai/feedback';
module.exports.AI_QUALITY = '/api/v1/ai/quality';
module.exports.AI_ASK_BUILD = '/api/v1/ai/ask/build';
module.exports.AI_ASK_CREATE_TASKS = '/api/v1/ai/ask/create-tasks';
module.exports.AI_MEMORY = '/api/v1/ai/memory';
module.exports.AI_MEMORY_IMPORT_PREVIEW = '/api/v1/ai/memory/import/preview';
module.exports.AI_MEMORY_IMPORT_CONFIRM = '/api/v1/ai/memory/import/confirm';
module.exports.TASK_COMPLETION = '/api/v2/tasks/completion';
module.exports.SCIM_CONFIG = '/api/v2/scim/config';
module.exports.SCIM_TOKEN = '/api/v2/scim/token';
module.exports.PTO = '/api/v1/pto';
module.exports.PORTFOLIO = '/api/v1/portfolio';
module.exports.CUSTOM_REPORT = '/api/v1/reports/custom';
module.exports.CUSTOM_REPORT_TEMPLATES = '/api/v1/reports/custom/templates';
module.exports.REPORT_SCHEDULES = '/api/v1/reports/schedules';
module.exports.AGILE_BURNDOWN = '/api/v1/agile/burndown';
module.exports.AGILE_VELOCITY = '/api/v1/agile/velocity';
module.exports.AGILE_CFD = '/api/v1/agile/cfd';
module.exports.AGILE_SPRINT_INSIGHTS = '/api/v1/agile/sprint-insights';
module.exports.AGILE_MILESTONES = '/api/v1/agile/milestones';
module.exports.AGILE_PROVENANCE = '/api/v1/agile/provenance';
module.exports.PORTFOLIO_SUMMARY = '/api/v1/portfolio/summary';
module.exports.VARIANCE_REPORT = '/api/v1/reports/variance';
module.exports.CAPACITY = '/api/v1/reports/capacity';
module.exports.EMAIL_IN = '/api/v1/email-in';
module.exports.CALENDAR_FEED = '/api/v1/calendar';
module.exports.AUTOMATIONS = '/api/v1/automations';
module.exports.AUTOMATIONS_V2 = '/api/v2/automations';
module.exports.INTEGRATIONS = '/api/v1/integrations';
// AHE-3838 — cloud storage attachments (Google Drive / Dropbox).
module.exports.CLOUD_STORAGE = '/api/v1/cloud-storage';
module.exports.EXPORT_CSV = '/api/v1/export/csv';
module.exports.EXPORT_XLSX = '/api/v1/export/xlsx';
module.exports.MAIN_CHATS = '/api/v1/main-chats'
module.exports.ACTIVITYLOG = '/api/v1/activity-log'
module.exports.SETTING_CATEGORY = '/api/v1/setting/category';
module.exports.SETTING_ROLES = '/api/v1/setting/roles';
module.exports.SETTING_DESIGNATION = '/api/v1/setting/designation';
module.exports.SETTING_PROJECT_SKILLS = '/api/v1/setting/skills';
module.exports.SETTING_COMPANY_USER_STATUS = '/api/v1/setting/companyUserStatus';
module.exports.FILE_EXTENSIONS = '/api/v1/fileExtensions';
module.exports.COMMON_DATE_FORMATE = '/api/v1/commonDateFormate';
module.exports.TASK_PRIORITY = '/api/v1/taskPriority'
module.exports.MILESTONE_BILLING_PERIOD = '/api/v1/milestoneBillingPeriod';
module.exports.MILESTONE_STATUS = '/api/v1/milestoneStatus';
module.exports.MILESTONE_RANGE = '/api/v1/milestoneRange';
module.exports.MEDIA_FILES = '/api/v1/mediaFiles';
module.exports.MEDIA_FILES_USERS = '/api/v1/groupByUsers';
module.exports.TASK = '/api/v1/task';
module.exports.TASK_DATA = '/api/v1/projectdata/taskData'
module.exports.PLANFEATUREDISPLAY = '/api/v1/plan-feature-display';
module.exports.SUBSCRIPTIONPLAN = '/api/v1/subscription';
module.exports.TASK_DATA = '/api/v1/projectdata/taskData';
module.exports.SET_CHATS = '/api/v1/main-chats/find';
module.exports.SUBSCRIPTIONS = "/api/v1/subscriptions";
module.exports.CUSTOMERUPDATE = "/api/v1/customer-update";
module.exports.GET_COMPANY = "/api/v1/admin/company";
module.exports.LOGOUT = '/api/v2/logout';
module.exports.GENERATEMONGOID = '/api/v1/generateMongoId';
module.exports.DASHBOARD= '/api/v1/dashboard'
module.exports.CARDCOMPONENT= '/api/v1/cardcomponent'
module.exports.DASHBOARDS = '/api/v1/dashboards'
// Resource Utilization & Consumption dashboard cards.
module.exports.PROJECT_UTILIZATION_SUMMARY = '/api/v1/dashboard/project-utilization-summary'
module.exports.MILESTONE_SUMMARY = '/api/v1/dashboard/milestone-summary'
module.exports.TEAM_TASKTYPE_BREAKDOWN = '/api/v1/dashboard/team-tasktype-breakdown'
module.exports.TEAM_LOGGED_VS_ETA = '/api/v1/dashboard/team-logged-vs-eta'
// Member self-view dashboard cards.
module.exports.MY_NEXT_TASKS = '/api/v1/dashboard/my-next-tasks'
module.exports.MY_LEAVE = '/api/v1/dashboard/my-leave'
module.exports.MY_ACHIEVEMENTS = '/api/v1/dashboard/my-achievements'
module.exports.MY_DUE_SOON = '/api/v1/dashboard/my-due-soon'
module.exports.AT_RISK = '/api/v1/dashboard/at-risk';
module.exports.MY_TIME = '/api/v1/dashboard/my-time'
module.exports.API_TIME_FORCASTING_REPORT ='/api/v1/report/time-forcasting';
module.exports.CUSTOME_MODALS = '/api/v1/customeModals'
module.exports.API_OAUTH_GITHUB = '/api/v1/github';
module.exports.API_OAUTH_GOOGLE = '/api/v1/google';
module.exports.API_OAUTH_GITLAB = '/api/v1/gitlab';
module.exports.GET_CHANGELOG = '/api/v2/changelog';
module.exports.TASKS_BY_STATUS = '/api/v1/dashboard/tasks-by-status';
module.exports.INBOX = '/api/v1/inbox';
module.exports.GLOBAL_SEARCH = '/api/v2/search';
module.exports.RECENT_VISITS = '/api/v2/recent-visits';
module.exports.USER_SESSIONS = '/api/v2/users/sessions';
module.exports.USER_ONBOARDING = '/api/v2/users/onboarding';
module.exports.USER_NAV_PREFERENCES = '/api/v2/users/nav-preferences';
module.exports.USER_FAVOURITES = '/api/v2/users/favourites';
module.exports.USER_HOME_CARDS = '/api/v2/users/home-cards';
module.exports.NOTIFICATION_PREFERENCES = '/api/v1/notifications/preferences';
module.exports.PAGES = '/api/v2/pages';
module.exports.PERSONAL_PROJECT = '/api/v1/project/personal';
module.exports.TIMESHEET_WEEK = '/api/v1/timesheet/week';
module.exports.TIMESHEET_BILLABLE_ENTRIES = '/api/v1/timesheet/entries/billable';
module.exports.WORKLOAD_GRID = '/api/v1/timesheet/workload-grid';
module.exports.WORKLOAD_MOVE = '/api/v1/timesheet/workload-move';
module.exports.WORKLOAD_CAPACITY = '/api/v1/timesheet/workload-capacity';
module.exports.TIMER_RUNNING = '/api/v2/timetracker/running';
module.exports.TIMER_TRIM = '/api/v2/timetracker/trim';
module.exports.TIMER_CAN_START = '/api/v2/timetracker/can-start';
module.exports.TIMESHEET_APPROVAL_QUEUE = '/api/v2/timesheet-approval/queue';
module.exports.CAPACITY_MONTHS = '/api/v1/reports/capacity/months';
module.exports.VARIANCE_SUMMARY = '/api/v1/reports/variance/summary';

// Project billing (handoff 19a–19d)
module.exports.BILLING_CONTRACT = '/api/v2/billing/contract';
module.exports.BILLING_MILESTONE = '/api/v2/billing/milestone';
module.exports.BILLING_HOURLY = '/api/v2/billing/hourly';
module.exports.BILLING_CLIENT_VIEW = '/api/v2/billing/client-view';
module.exports.BILLING_CLIENT_MESSAGE = '/api/v2/billing/client-view/message';
module.exports.PROJECT_INVOICES = '/api/v2/invoices';
module.exports.EXPORT_PDF = '/api/v1/export/pdf';
module.exports.PUBLIC_SHARES = '/api/v2/public-shares';

// Custom fields — sandboxed formula/rollup evaluation (handoff 22a)
module.exports.CUSTOM_FIELD_FORMULA_SCOPE = '/api/v2/custom-fields/formula/scope';
module.exports.CUSTOM_FIELD_FORMULA_VALIDATE = '/api/v2/custom-fields/formula/validate';
module.exports.CUSTOM_FIELD_COMPUTE = '/api/v2/custom-fields/compute';
module.exports.CUSTOM_FIELDS_V2 = '/api/v2/custom-fields';

// CSV import (handoff 22b)
module.exports.IMPORT_CSV = '/api/v2/imports/csv';
module.exports.IMPORT_CSV_PREVIEW = '/api/v2/imports/csv/preview';
module.exports.IMPORT_CLICKUP = '/api/v2/imports/clickup';
module.exports.IMPORT_CLICKUP_PREVIEW = '/api/v2/imports/clickup/preview';
module.exports.IMPORT_CLICKUP_PROJECT = '/api/v2/imports/clickup/project';
module.exports.IMPORTS = '/api/v2/imports';
module.exports.EXPORTS = '/api/v2/exports';
module.exports.EXPORTS_WORKSPACE = '/api/v2/exports/workspace';

// Per-status WIP limit on a project's board columns
module.exports.PROJECT_WIP_LIMIT = '/api/v1/projectSetting/taskStatus/wipLimit';

// First-run setup (Modules/Setup) and the operator guide the setup and Instance pages link to
module.exports.SETUP_STATUS = '/api/v2/setup/status';
module.exports.SETUP_COMPLETE = '/api/v2/setup/complete';
module.exports.SETUP_EVENTS = '/api/v2/setup/events';
module.exports.ADMIN_GUIDE_URL = 'https://github.com/aliansoftwareteam/AlianHub-Project-Management-System/blob/main/docs/ADMIN-GUIDE.md';

// Instance console (Modules/Instance); public-config is the only public one
module.exports.INSTANCE_PUBLIC_CONFIG = '/api/v2/instance/public-config';
module.exports.INSTANCE_ACCESS = '/api/v2/instance/access';
module.exports.INSTANCE_SETTINGS = '/api/v2/instance/settings';
module.exports.INSTANCE_SETTINGS_TEST = '/api/v2/instance/settings/test';
module.exports.INSTANCE_HEALTH = '/api/v2/instance/health';
module.exports.INSTANCE_MAINTENANCE = '/api/v2/instance/maintenance';
module.exports.INSTANCE_UPGRADE = '/api/v2/instance/upgrade';
module.exports.INSTANCE_MIGRATIONS_RUN = '/api/v2/instance/migrations/run';
module.exports.INSTANCE_LOGS = '/api/v2/instance/logs';
module.exports.INSTANCE_LOG_FILES = '/api/v2/instance/logs/files';
module.exports.INSTANCE_LOG_DOWNLOAD = '/api/v2/instance/logs/download';
module.exports.INSTANCE_BACKUPS = '/api/v2/instance/backups';
module.exports.INSTANCE_ORPHAN_DATABASES = '/api/v2/instance/orphan-databases';
module.exports.INSTANCE_AI_PROVIDERS = '/api/v2/instance/ai/providers';
module.exports.INSTANCE_STATS = '/api/v2/instance/stats';
module.exports.APP_VERSION = '/version';
module.exports.REPO_URL = 'https://github.com/aliansoftwareteam/AlianHub-Project-Management-System';
module.exports.INSTANCE_COMPANIES = '/api/v2/instance/companies';
module.exports.INSTANCE_AUDIT_EXPORT = '/api/v2/instance/audit-export';
module.exports.INSTANCE_AUDIT = '/api/v2/instance/audit';
module.exports.INSTANCE_ENFORCEMENT = '/api/v2/instance/enforcement';
module.exports.INSTANCE_CSP = '/api/v2/instance/csp';
module.exports.INSTANCE_EGRESS = '/api/v2/instance/egress';
module.exports.INSTANCE_INSTRUCTION_PATTERNS = '/api/v2/instance/instruction-patterns';
module.exports.INSTANCE_KNOWLEDGE = '/api/v2/instance/knowledge';

// The storage flag is decided by the server at runtime; build-time VUE_APP_STORAGE_TYPE is only the fallback
module.exports.setRuntimeConfig = (cfg) => { if (cfg && cfg.storageType) module.exports.STORAGE_TYPE = cfg.storageType; };
